import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import Vue from 'vue';

export default function () {
    Bugsnag.start({
        apiKey: window.credManager.bugsnagApiKey(),
        plugins: [new BugsnagPluginVue()],
    })
    const bugsnagVue = Bugsnag.getPlugin('vue');
    bugsnagVue.installVueErrorHandler(Vue);
}
